import $ from 'jquery';

// bootstrap.bundle and bootstrap-datepicker look for jQuery on the window.
window.$ = window.jQuery = window.jquery = $;
